/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{rgba as s}from"./rgba.js";import{isColorString as r}from"./utils.js";const t={test:r("#"),parse:function(s){let r="",t="",n="",e="";return s.length>5?(r=s.substring(1,3),t=s.substring(3,5),n=s.substring(5,7),e=s.substring(7,9)):(r=s.substring(1,2),t=s.substring(2,3),n=s.substring(3,4),e=s.substring(4,5),r+=r,t+=t,n+=n,e+=e),{red:parseInt(r,16),green:parseInt(t,16),blue:parseInt(n,16),alpha:e?parseInt(e,16)/255:1}},transform:s.transform};export{t as hex};
//# sourceMappingURL=hex.js.map
